import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";
import { requestCommonSearch } from "../../common/requests";
import {
  BILLING_MODE_LOADING,
  BILLING_MODE_ERROR,

  BILLING_MODE_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/tariff/billing";

export const setLoading = (status) => ({
  type: BILLING_MODE_LOADING,
  payload: status
});

export const search = (page = 0, size = 20, sort = "price,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then(response => {
      dispatch({
        type: BILLING_MODE_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, BILLING_MODE_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/billing-mode-tariff/actions.js